/**
 * AdminAvatar — a small initials circle used in admin people lists
 * (students, judges, campus admins, team). Replaces the bespoke
 * initials-badge re-implemented across those screens. Theme-driven.
 */
import { Text, View } from "react-native";

import { RADII } from "../../../lib/brand";
import type { PaneTheme } from "../../brand/paneThemes";

export function makeInitials(name: string | null | undefined, fallback = "?"): string {
  if (!name?.trim()) return fallback;
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function AdminAvatar({
  theme,
  name,
  size = 36,
  fallback = "?",
}: {
  theme: PaneTheme;
  name: string | null | undefined;
  size?: number;
  fallback?: string;
}) {
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: RADII.full,
        backgroundColor: theme.accentSoft,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Text style={{ fontFamily: theme.displayMediumFont, fontSize: size * 0.39, color: theme.accent }}>
        {makeInitials(name, fallback)}
      </Text>
    </View>
  );
}
